import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// ── FORCE-CLEAR STUCK SERVICE WORKERS ──
// service-worker.js was caching stale JS bundles, so users kept seeing old
// code after deploys. This runs once per browser session, unregisters any
// service worker, wipes Cache Storage, and reloads once to guarantee fresh
// assets. The old "register service worker on load" block has been removed
// entirely — that registration was the source of the stale-cache problem.
if ("serviceWorker" in navigator) {
  const alreadyCleared = sessionStorage.getItem("sw_force_cleared");

  if (!alreadyCleared) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      const unregisterPromises = registrations.map((reg) => reg.unregister());

      const clearCaches = "caches" in window
        ? caches.keys().then((names) => Promise.all(names.map((name) => caches.delete(name))))
        : Promise.resolve();

      Promise.all([...unregisterPromises, clearCaches]).then(() => {
        sessionStorage.setItem("sw_force_cleared", "true");
        window.location.reload();
      });
    });
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();